<div *ngIf="isNotView" class="background" style="background-color: #1d2229">
  <nav
    class="navbar"
    style="
      background-color: #1d2229;
      text-align: center;
      margin-left: 2px;
      height: 8vh;
    "
  >
    <div class="container-fluid">
      <a class="navbar-brand" href="#">
        <img
          src="/assets/Scania/Scania_Clock.png"
          class="img-fluid"
          alt="Logo"
        />
        <button
          type="button"
          class="btn btn-outline-primary"
          *ngIf="!loginDisplay"
          (click)="login()"
          style="margin-left: 84vw"
        >
          Login
        </button>
        <button
          type="button"
          class="btn btn-outline-primary"
          *ngIf="loginDisplay"
          (click)="logout()"
          style="margin-left: 84vw"
        >
          Logout
        </button>
      </a>
    </div>
  </nav>
</div>
<router-outlet *ngIf="!isIframe"></router-outlet>
